<kb-main-grid>
  <div kb-grid-item-columns="12"></div>
  <h1 kb-grid-item-columns="12" kb-heading i18n="Not found error page title@@6595008830732269870">Not found</h1>

  <section kb-section kb-grid-item-columns="8">
    <p kb-paragraph>
      <strong i18n="Not found error page abstract@@3765160460129555695">
        The link you opened points to a page that does not exist.<br>
        This can happen if a page was moved or deleted.<br>
        If you think this page should exist, please provide the following information:
      </strong>
    </p>
    <kb-table>
      <table>
        <tbody>
          <tr>
            <!-- eslint-disable-next-line @angular-eslint/template/i18n -->
            <th scope="row">URL</th>
            <td>{{ url }}</td>
          </tr>
          <tr>
            <!-- eslint-disable-next-line @angular-eslint/template/i18n -->
            <th scope="row">Time</th>
            <td>{{ time | date:'M/d/y H:mm:ss z' }}</td>
          </tr>
          <tr>
            <!-- eslint-disable-next-line @angular-eslint/template/i18n -->
            <th scope="row">Referrer</th>
            <td>{{ getReferer() }}</td>
          </tr>
        </tbody>
      </table>
    </kb-table>
  </section>
</kb-main-grid>
